import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";
import { Bundle, BundledItem } from "../api/contracts/catalog/bundles";
import { Company } from "../api/contracts/companies";
import { ContractStatus } from "../api/contracts/partners";

export enum BundleState {
  preContract,
  preApproval,
  postApproval
}

export const getBundleState = (customer: Company) => {
  if (customer.contractStatus === ContractStatus.Pending) return BundleState.preContract;

  return customer.needsJobBundleApproval ? BundleState.preApproval : BundleState.postApproval;
};

// export interface PreStoredJobBundle {
//   description: string;
//   code?: string;
//   id: string;
//   name: string;
//   maxBinLevel: number;
//   minBinLevel: number;
//   bundledProducts: {
//     id: string;
//     price: number | undefined;
//     name: string;
//     count: number;
//   }[];
//   unbundledProducts: {
//     id: string;
//     name: string;
//     count: number;
//   }[];
//   isCatalogBundle?: boolean;
//   flaggedForDelete?: boolean;
// }
// export interface PreStoredPurchaseOrderBundle {
//   id: string;
//   name: string;
//   code: string;
//   company: Company;
//   bundledProducts: {
//     id: string;
//     price: number | undefined;
//     mspPrice: number | undefined;
//     name: string;
//     count: number;
//   }[];
// }

// const getProductsInBundle = (bundle: JobBundle, products: Product[]) => {
//   return bundle.bundledItems
//     .filter(bundledItem => bundledItem.count > 0)
//     .map(bundledItem => {
//       const product = products.find(product => product.id === bundledItem.catalogItem);
//       if (!product) throw new Error('Product not found');
//       return [product, bundledItem] as const;
//     });
// };

// const getProductsInPurchaseOrderBundle = (bundle: PurchaseOrderBundle, products: Product[]) => {
//   return bundle.bundledItems
//     .filter(bundledItem => bundledItem.count > 0)
//     .map(bundledItem => {
//       const product = products.find(product => product.id === bundledItem.catalogItem);
//       if (!product) throw new Error('Product not found');
//       return [product, bundledItem] as const;
//     });
// };

// const getProductsInBinLevel = (bundle: JobBundle, products: Product[]) => {
//   return bundle.unbundledItems
//     .filter(unbundledItem => unbundledItem.count > 0)
//     .map(unbundledItem => {
//       const product = products.find(product => product.id === unbundledItem.catalogItem);
//       if (!product) throw new Error('Product not found');
//       return [product, unbundledItem] as const;
//     });
// };


export interface BaseBundleArgs {
  name: string;
  mainDevice?: string;
  bundledItems: BundledItem[];
}

export interface EditBundleArgs extends BaseBundleArgs {
  id: string;
}

export interface BundleService {
  bundleState: BundleState;
  bundles: Bundle[];
  getBundleById: (id: string) => Bundle | null;
  createBundle: (data: BaseBundleArgs) => Promise<void>;
  deleteBundle: (id: string) => Promise<void>;
  editBundle: (data: EditBundleArgs) => Promise<void>;
  // purchaseOrderBundle: PreStoredPurchaseOrderBundle;
  // inEditMode: boolean;
  // setEditMode: (edit: boolean) => void;
  // updateProductInPurchaseOrderBundle: (data: { bundleId: string; productId: string; count: number }) => Promise<void>;
  // updateProductBinLevelInBundle: (data: { bundleId: string; productId: string; count: number }) => Promise<void>;
  // updateBundleBinLevel: (data: { bundleId: string; maxBinLevel: number; minBinLevel: number }) => Promise<void>;
  // saveChangesToBundle: () => Promise<void>;
}

export const BundleContext = createContext<StoreApi<BundleService> | null>(null);

export function useBundle<U>(selector: (store: BundleService) => U): U {
  const context = useContext(BundleContext);
  if (!context) {
    throw new Error('useJobBundle must be used within a JobBundleProvider');
  }
  return useStore(context, selector);
}

// export function useJobBundlesToSave() {
//   return useBundle(state => state.bundles);
// }
